import { useEffect, useState } from "react";
import zxcvbn from "zxcvbn";
import "./PasswordStrengthChecker.scss";

type P = {
  password: string;
  className?: string;
  isHidden?: boolean;
  // opcjonalny callback – jeśli nie podany, komponent działa jak wcześniej
  onStrengthChange?: (value: "weak" | "medium" | "strong") => void;
};

const PasswordStrengthChecker = ({
  password,
  className = "",
  isHidden,
  onStrengthChange,
}: P) => {
  const [passwordStrength, setPasswordStrength] = useState(0);
  const [passwordStrengthValue, setPasswordStrengthValue] = useState<
    "weak" | "medium" | "strong"
  >("weak");

  useEffect(() => {
    setPasswordStrength(zxcvbn(password).score);
  }, [password]);

  useEffect(() => {
    let next: "weak" | "medium" | "strong" = "weak";

    if (passwordStrength > 3) {
      next = "strong";
    } else if (passwordStrength > 1) {
      next = "medium";
    }

    setPasswordStrengthValue(next);

    if (onStrengthChange) {
      onStrengthChange(next);
    }
  }, [passwordStrength, onStrengthChange]);

  return (
    <div
      className={`password-strength-checker ${
        isHidden ? "password-strength-checker--hidden" : ""
      } ${className}`}
    >
      <span
        className={`password-strength-checker__bar password-strength-checker__bar--${passwordStrengthValue}`}
      >
        <p
          className={`password-strength-checker__label ${
            passwordStrengthValue === "weak"
              ? "password-strength-checker__label--active"
              : ""
          }`}
        >
          {"Słabe"}
        </p>
        <p
          className={`password-strength-checker__label  ${
            passwordStrengthValue === "medium"
              ? "password-strength-checker__label--active"
              : ""
          } `}
        >
          {"Średnie"}
        </p>
        <p
          className={`password-strength-checker__label   ${
            passwordStrengthValue === "strong"
              ? "password-strength-checker__label--active"
              : ""
          }`}
        >
          {"Silne"}
        </p>
      </span>
      <span
        className={`password-strength-checker__bar ${
          passwordStrength > 1
            ? `password-strength-checker__bar--${passwordStrengthValue}`
            : ""
        }`}
      ></span>
      <span
        className={`password-strength-checker__bar ${
          passwordStrength > 3
            ? `password-strength-checker__bar--${passwordStrengthValue}`
            : ""
        }`}
      ></span>
    </div>
  );
};

export default PasswordStrengthChecker;
